// extracted by mini-css-extract-plugin
module.exports = {"wrapper_page_error":"ResourceErrorStyle_wrapper_page_error__2_GWj","button_error":"ResourceErrorStyle_button_error__eCNAr"};